import styled from "styled-components";

export const EditorInfoSearchWrapper = styled.div`
  display: flex;
  align-items: center;
`;
